import styled, { keyframes, css } from 'styled-components'
import { colors, media } from 'client/styles'

const fadeInEffect = keyframes`
  0% { opacity: 0  }
  100% { opacity: 1 }
`

export const NotificationBase = styled.div`
  display: flex;
  animation: ${fadeInEffect} 0.3s linear;
  background-color: ${colors.grey1};
  border-radius: 8px;
  margin-block-end: 20px;
  opacity: 1;
  padding-block: 12px;
  padding-inline: 12px;
  width: 300px;
  color: ${colors.white};
  svg {
    fill: ${colors.white};
  }
`

export const NotificationClose = styled.div`
  margin-inline-end: 10px;
  svg {
    cursor: pointer;
  }
`

export const NotificationContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

const reverse = css`
  ${NotificationBase} {
    flex-direction: row-reverse;
    width: 380px;
    ${NotificationClose} {
      margin-inline-end: 0px;
      margin-inline-start: 10px;
    }
  }
`

export const NotificationsBase = styled.div`
  ${props => props.reverse && reverse}
  display: none;

  ${media.tablet} {
    display: block;
  }
`
